import './Footer.css';
import { BUILD_DATE } from '../../build-info';

export function Footer({}: {}) {
    return (
        <footer className='footer'>
            <p>Build from {BUILD_DATE.toUTCString()}</p>
        </footer>
    );
}
export default Footer;
